module.exports = __webpack_public_path__ + "static/media/failure-low.7a4840c3.7a4840c3.svg";